import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ClientDashboard } from '@models';
import { Observable, Subscription, timer } from 'rxjs';
import { ModalNewInvitationService } from '@modules';
import { ClientDashboardService } from './client-dashboard.service';

@Component({
  selector: 'ggi-journey-client-dashboard',
  templateUrl: './client-dashboard.component.html',
  styleUrls: [
    './client-dashboard.component.scss',
    '../client-container.component.scss',
  ],
})
export class ClientDashboardComponent implements OnInit, OnDestroy {
  public getDashboard$: Observable<ClientDashboard>;

  private hourInSeconds = 60 * 60;
  private limitHoursInSeconds = 3 * this.hourInSeconds;

  private subscriptions: Subscription[] = [];

  constructor(
    private readonly dashboardService: ClientDashboardService,
    private readonly service: ModalNewInvitationService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.getDashboard();

    this.setHistoryTimer();
  }

  private getDashboard(): void {
    this.getDashboard$ = this.dashboardService.getDashboard();
  }

  public openInvitationModal(id: string): void {
    this.service.open();
    this.service.visitIdForModal(id);
  }

  public goToDetail(id: string, visitType: string): void {
    this.router.navigate(['/cliente/visit-detail/'], {
      queryParams: {
        visitId: id,
        visitType,
      },
    });
  }

  private setHistoryTimer(): void {
    this.subscriptions.push(
      this.dashboardService.seconds.subscribe((seconds) => {
        if (seconds > 0 && seconds < this.limitHoursInSeconds) {
          this.subscriptions.push(
            timer(seconds * 1000).subscribe((_) => {
              this.getDashboard();
            })
          );
        }
      })
    );
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
